import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { CARD_FORMATTER_IFRAME_LOOKUP_KEYS } from '../constants/IframeLookupKeys';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FullContainerTileCardFormatter({
  title: __title,
  actionConfigs: __actionConfigs,
  children,
  legacyDataAttributes: {
    ['data-sidebar-card-type']: legacyDataSidebarCardType,
    ['data-sidebar-card-association-object-type-id']: legacyDataSidebarCardAssociationObjectTypeId,
    ['data-sidebar-key']: legacyDataSidebarKey
  } = {},
  cardType
}) {
  return /*#__PURE__*/_jsx(CardWrapper, {
    "data-sidebar-card-type": legacyDataSidebarCardType,
    "data-sidebar-card-association-object-type-id": legacyDataSidebarCardAssociationObjectTypeId,
    "data-sidebar-key": legacyDataSidebarKey,
    "data-card-type": cardType,
    blockSize: "100%",
    position: "relative",
    marginBlockEnd: "0",
    children: children
  });
}
FullContainerTileCardFormatter.iframeLookupKey = CARD_FORMATTER_IFRAME_LOOKUP_KEYS.FULL_CONTAINER_TILE_CARD_FORMATTER;